import { callables as metadataCallables } from "./metadata/callables";
import { callables as workspaceCallables } from "./workspaces/callables";
import { callables as workspaceUsersCallables } from "./workspaceUsers/callables";
import { callables as workspaceUserGroupsCallables } from "./workspaceUserGroups/callables";
import { callables as workspaceResourceFoldersCallables } from "./workspaceResourceFolders/callables";
import { callables as subscriptionsCallables } from "./workspaceBilling/callables";
import { callables as workspaceUserInvitesCallables } from "./workspaceUserInvites/callables";
import { callables as workspaceIntegrationsCallables } from "./workspaceIntegrations/callables";
import { callables as enterpriseCallables } from "./enterprise/callables";
import { callables as collaborationInvitesCallables } from "./collaborationInvites/callables";

export { apiName } from "./endpoints";

export const callables = {
    ...metadataCallables,
    ...workspaceCallables,
    ...workspaceUsersCallables,
    ...workspaceUserGroupsCallables,
    ...workspaceResourceFoldersCallables,
    ...subscriptionsCallables,
    ...workspaceUserInvitesCallables,
    ...workspaceIntegrationsCallables,
    ...enterpriseCallables,
    ...collaborationInvitesCallables
};
